import { type ReactNode } from 'react';

interface ReportSectionProps {
  title: string;
  children: ReactNode;
  // Sektioner med egna kort (statgrid) bär inte den vita rutan själva.
  plain?: boolean;
}

export const ReportSection = ({ title, children, plain = false }: ReportSectionProps) => (
  <section>
    <h2 className="mb-3 text-lg font-semibold text-slate-900">{title}</h2>
    {plain ? (
      children
    ) : (
      <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">{children}</div>
    )}
  </section>
);
